var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-form__form"},[_c('form-question',{attrs:{"number":_vm.currentQuestionIndex + 1,"question":_vm.question,"show-number":_vm.question.type !== 'submit'}}),_c('form-answer',{attrs:{"question":_vm.question,"submit-btn-txt":_vm.submitBtnTxt},on:{"answer":_vm.registerAnswer,"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }